import styled from 'styled-components';

import {ms} from '../../../../styles/normalizeSize';
import {View} from '../../../../uikit/View';
import {CountriesListItem} from '../../containers/CountriesListItem';

export const SearchTextInputContainer = styled(View)`
  margin-bottom: ${ms(10)};
  flex-direction: column;
  padding-inline: ${ms(20)};
`;

export const ListContainer = styled(View)`
  height: 60vh;
  flex-direction: column;
`;

export const ListItem = styled(CountriesListItem)`
  padding: ${ms(8)} 0;
`;
